<template>
  <div class="help-content-box">
    <div class="help-content">
      <div class="video-introduction mb20">
        <div class="title">{{ $t('key1006757') }}</div>
        <div class="video-item bottom-border">
          <div class="sub-title">{{ $t('key1001728') }}</div>
          <div class="video-item-desc" @click="gotoPage(1)">
            <span class="desc">{{ $t('key1001728') }}</span>
            <img class="play" :src="playIcon"/>
            <img class="play-h" :src="playHoverIcon"/>
          </div>
        </div>
        <div class="video-item video-item-tit">
          <div class="sub-title">{{ $t('key1006758') }}</div>
        </div>
        <div class="video-item mb25">
          <div class="sub-title sub-title-t">{{ $t('key1006759') }}</div>
          <div class="video-item-desc" @click="gotoPage(6)">
            <span class="desc">{{ $t('key1001730') }}</span>
            <img class="play" :src="playIcon"/>
            <img class="play-h" :src="playHoverIcon"/>
          </div>
        </div>
        <div class="video-item">
          <div class="sub-title sub-title-t">{{ $t('key1006760') }}</div>
          <div class="video-item-desc" @click="gotoPage(2)">
            <span class="desc">{{ $t('key1001731') }}</span>
            <img class="play" :src="playIcon"/>
            <img class="play-h" :src="playHoverIcon"/>
          </div>
        </div>
      </div>
      <div class="video-introduction">
        <div class="title">
          <p>{{ $t('key1006761') }}</p>
          <div class="title-desc">{{ $t('key1006762') }} + {{ $t('key1006763') }} + {{ $t('key1006764') }}</div>
        </div>
        <div class="video-item mb25">
          <div class="sub-title sub-title-t">{{ $t('key1006765') }}</div>
          <div class="video-item-desc" @click="gotoPage(3)">
            <span class="desc">{{ $t('key1006766') }}</span>
            <img class="play" :src="playIcon"/>
            <img class="play-h" :src="playHoverIcon"/>
          </div>
        </div>
        <div class="video-item mb25">
          <div class="sub-title sub-title-t">{{ $t('key1006767') }}</div>
          <div class="video-item-desc" @click="gotoPage(5)">
            <span class="desc">{{ $t('key1006768') }}</span>
            <img class="play" :src="playIcon"/>
            <img class="play-h" :src="playHoverIcon"/>
          </div>
        </div>
        <div class="video-item">
          <div class="sub-title sub-title-t">{{ $t('key1006769') }}</div>
          <div class="video-item-desc" @click="gotoPage(4)">
            <span class="desc">{{ $t('key1001732') }}</span>
            <img class="play" :src="playIcon"/>
            <img class="play-h" :src="playHoverIcon"/>
          </div>
        </div>
      </div>
      <div class="videos"></div>
    </div>
  </div>
</template>

<script>
import Mixin from '@/components/mixin/common_mixin';

export default {
  name: 'helpVideoMore',
  mixins: [Mixin],
  data() {
    return {
      playIcon: require('@/assets/images/help/icon-play.png'),
      playHoverIcon: require('@/assets/images/help/icon-play-h.png'),
    };
  },
  props: {},
  watch: {},
  methods: {
    gotoPage(id) {
      const origin = window.location.origin;
      const env = this.systemEnvironment || 'yms';
      const base = origin.includes('localhost')
        ? `${origin}/vedio.html`
        : `${origin}/yms-shopping-service/vedio.html`;
      window.open(`${base}?id=${id}&env=${env}`, '_blank');
    },
  },
  components: {}
};
</script>

<style scoped lang="less">
.mb25 {
  margin-bottom: 25px;
}

.help-content-box {
  background-color: #f2f2f2;

  .help-content {
    width: 1200px;
    margin: 0 auto 25px auto;
  }
}

.video-introduction {
  padding: 32px 23px;
  background: #ffffff;

  .bottom-border {
    padding-bottom: 25px;
    border-bottom: 1px solid #EDEDED;
  }


  .title {

    font-size: 18px;
    font-weight: 600;
    color: #FF5310;
    margin-bottom: 20px;
  }

  .title-desc {
    font-weight: initial;
    color: #919DB1;
    font-size: 13px;
  }

  .video-item-tit {
    margin: 27px 0 20px 0;
  }

  .video-item {
    display: flex;
    align-items: center;

    .sub-title {
      min-width: 224px;
      font-size: 18px;
      font-weight: 600;
      color: #000000;
      line-height: 32px;
      padding-right: 15px;
    }

    .sub-title-t {
      font-weight: initial;
      font-size: 16px;
    }

    .video-item-desc {
      min-width: 260px;
      height: 60px;
      background: #FFFFFF;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      display: flex;
      padding: 0 20px;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      transition: box-shadow 0.2s ease;

      .desc {
        font-size: 16px;
        font-weight: 400;
        padding-right: 15px;
        color: #000000;
      }

      .play {
        display: block;
        width: 30px;
      }

      .play-h {
        display: none;
      }

      &:hover {
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);

        .play {
          display: none;
        }

        .play-h {
          display: block;
          width: 30px;
        }
      }
    }
  }
}
</style>
